var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.927,
    height: 18.927,
    viewBox: "0 0 20.927 18.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blog-svgrepo-com",
    transform: "translate(-3.75 -5.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31971",
    "data-name": "Rectangle 31971",
    width: 8,
    height: 1,
    rx: 0.5,
    transform: "translate(5 22)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31972",
    "data-name": "Rectangle 31972",
    width: 8,
    height: 1,
    rx: 0.5,
    transform: "translate(5 18)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34315",
    "data-name": "Path 34315",
    d: "M22.725,12.511H5.7a1.7,1.7,0,0,1-1.7-1.7V5.7A1.7,1.7,0,0,1,5.7,4H22.725a1.7,1.7,0,0,1,1.7,1.7v5.107A1.7,1.7,0,0,1,22.725,12.511ZM5.7,5.7v5.107H22.725V5.7Z",
    transform: "translate(0 2)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34316",
    "data-name": "Path 34316",
    d: "M24.809,26.511H19.7a1.7,1.7,0,0,1-1.7-1.7V19.7A1.7,1.7,0,0,1,19.7,18h5.107a1.7,1.7,0,0,1,1.7,1.7v5.107A1.7,1.7,0,0,1,24.809,26.511ZM19.7,19.7v5.107h5.107V19.7Z",
    transform: "translate(-2.084 -2.084)",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.0b70295dc6b898150d3cf1c7bdef9fb3.svg";
export { ForwardRef as ReactComponent };